import React, { useEffect, useMemo, useState } from 'react'
import { Box } from '@material-ui/core'
import { formatDate } from '~/utils/date'
import { createInstallments } from './utils'
import { creditSimulator } from '~/service/creditSimulator'
import { useAuthAccount } from '~/store/auth/useAuthAccount'
import { DocumentationOnboardContainer } from '../../components'
import { hasPreApprovedAccountStatus } from '~/utils/analysisStatus'
import { getRequiredDocumentsByProposalRisk, RequiredDocument } from '~/utils/documents'
import { Installment, InstallmentsTableContainer, RedirectPJAnalysisStep } from '~/components'
import { AttentionBadge, PreProposalBadge, ProposalInfoContainer, AccordionsContainer, Footer } from './components'
import { OnboardingRegisterDataActions, trackEvent } from '~/service/analytics'

export const PreProposal: React.FC = () => {
  const { onboardingLoanRequest, createdAt, pjAnalysisStatus } = useAuthAccount()
  const { proposalRisk, status } = pjAnalysisStatus
  const [requiredDocuments, setRequiredDocuments] = useState<RequiredDocument[]>([])
  const [installments, setInstallments] = useState<Installment[]>([])
  const [installmentValue, setInstallmentValue] = useState(0)
  const shouldRedirect = useMemo(() => !hasPreApprovedAccountStatus(status), [status])

  useEffect(() => {
    if (proposalRisk) {
      const documents = getRequiredDocumentsByProposalRisk(proposalRisk)
      setRequiredDocuments(documents)
    }
  }, [])

  useEffect(() => {
    if (onboardingLoanRequest) {
      const { numberOfInstallments, requestedAmountCents } = onboardingLoanRequest
      const simulation = creditSimulator({ requestedAmountCents, numberOfInstallments, createdAt })

      if (simulation) {
        setInstallmentValue(simulation.installmentValue)
        const createdInstallments = createInstallments({
          numberOfInstallments,
          installmentValue: simulation.installmentValue
        })
        setInstallments(createdInstallments)
      }
    }
  }, [])

  useEffect(() => {
    trackEvent(OnboardingRegisterDataActions.PRE_PROPOSAL_PAGE)
  }, [])

  if (shouldRedirect) {
    return (
      <RedirectPJAnalysisStep
        status={status}
      />
    )
  }

  return (
    <DocumentationOnboardContainer
      title='Confira a pré-proposta de crédito para sua empresa'
      customHeader='Pré proposta'
    >
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 5
      }}
      >
        <PreProposalBadge
          loanCreatedAt={formatDate(createdAt)}
          numberOfInstallments={onboardingLoanRequest?.numberOfInstallments}
          requestedAmountCents={onboardingLoanRequest?.requestedAmountCents}
          installmentValue={installmentValue}
        />

        <ProposalInfoContainer
          title='Fluxo previsto de pagamento'
          description='Veja abaixo um resumo das primeiras e últimas parcelas do seu empréstimo.'
          isSmallTitle
        >
          <InstallmentsTableContainer installments={installments} />
          <AttentionBadge />
        </ProposalInfoContainer>

        <ProposalInfoContainer
          title='Próximos passos'
          description='Veja abaixo as próximas etapas para obter uma análise de crédito personalizada e contratar o crédito conosco.'
        >
          <AccordionsContainer
            requiredDocuments={requiredDocuments}
          />
        </ProposalInfoContainer>

        <Footer />
      </Box>
    </DocumentationOnboardContainer>
  )
}
